import { v4 as uuid } from 'uuid';

/** UUID for frontend error correlation without depending on `crypto.randomUUID` in older Safari. */
export const newRequestId = (): string =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : uuid();

/** First 8 chars — short enough to read aloud / paste in support tickets. */
export const shortRequestId = (id: string): string => id.slice(0, 8);
